import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'
import Page403 from '@/components/Page403'
import Bug from '@/components/Bug';
import Search from '@/components/Search';
import HelpContractStatuses from '@/components/HelpContractStatuses';

import globals from '@/globals'

// Layouts
import Layout from '@/layout/Layout1';
import Layout2 from '@/layout/Layout2';
import LayoutBlank from '@/layout/LayoutBlank';
import LayoutPrint from '@/layout/LayoutPrint';

//Pages
import Dashboard from '@/components/Dashboard';
import Login from '@/components/Login';
import Profile from '@/components/users/Profile';

//ADMIN
import AdminBilling from '@/components/admin/Billing';
import AdminSettings from '@/components/admin/Settings';
import AdminDoNotContactCode from '@/components/admin/DoNotContactCode';
import AdminMarketerRelationshipCode from '@/components/admin/MarketerRelationshipCode';
import AdminContractStatus from '@/components/admin/ContractStatus';
import AdminProductType from '@/components/admin/ProductType';
import AdminDeleteProductType from '@/components/admin/DeleteProductType';

//Agency
import AgencyIndex from '@/components/agencies/Index';
import AgencyView from '@/components/agencies/View';
import AgencyEdit from '@/components/agencies/Edit';

//Agents
import AgentIndex from '@/components/agents/Index';
import AgentView from '@/components/agents/View';
import AgentEdit from '@/components/agents/Edit';
import AgentDelete from '@/components/agents/Delete';

//Carriers
import CarrierIndex from '@/components/carriers/Index';
import CarrierView from '@/components/carriers/View';
import CarrierEdit from '@/components/carriers/Edit';
import CarrierDelete from '@/components/carriers/Delete';

//Carriers
import ClientIndex from '@/components/clients/Index';
import ClientView from '@/components/clients/View';
import ClientEdit from '@/components/clients/Edit';

//Contacts
import ContactEdit from '@/components/contacts/Edit';
import ContactDelete from '@/components/contacts/Delete';

//Comments
import CommentsIndex from '@/components/comments/Index';

//Contracts
import ContractIndex from '@/components/contracts/Index';
import ContractEdit from '@/components/contracts/Edit';
import ContractView from '@/components/contracts/View';
import ContractDelete from '@/components/contracts/Delete';
import ContractDeactivate from '@/components/contracts/Deactivate';
import DeleteContractLevelChange from '@/components/contracts/DeleteChange';

//FILE
import FileEdit from '@/components/files/Edit';
import FileDelete from '@/components/files/Delete';

//Policies
import PolicyIndex from '@/components/policies/Index';
import PolicyView from '@/components/policies/View';
import PolicyEdit from '@/components/policies/Edit';

//PRODUCTS
import ProductIndex from '@/components/products/Index';
import ProductView from '@/components/products/View';
import ProductEdit from '@/components/products/Edit';
import ProductImport from '@/components/products/Import';
import ProductSyncLevels from '@/components/products/SyncLevels';
import ProductDelete from '@/components/products/Delete';
import ProductDeactivate from '@/components/products/Deactivate';
import ProductImportLevels from '@/components/products/ImportLevelMapping';
import ProductLevelHistory from '@/components/products/LevelHistory';

//REPORTS
import ReportDownline from '@/components/reports/Downline';
import ReportCustom from '@/components/reports/Custom';
import ReportIndex from '@/components/reports/Index';
import ReportView from '@/components/reports/View';
import ReportDelete from '@/components/reports/Delete';
import ReportEditSchedule from '@/components/reports/EditSchedule';

//Setup Schedule List
import ScheduleIndex from '@/components/reports/ScheduleIndex';

//USERS
import UserIndex from '@/components/users/Index';
import UserView from '@/components/users/View';
import UserEdit from '@/components/users/Edit';
import UserResetPassword from '@/components/users/ResetPassword';
import UserImpersonate from '@/components/users/Impersonate';

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout2,
      children: [
        { path: '/', component: Dashboard },
        { path: 'bug', component: Bug },
        { path: '404', name: '404', component: NotFound },
        { path: '403', name: '403', component: Page403, props: true},
        { path: 'profile', name: 'Profile', component: Profile },
        { path: 'search', component: Search },
        { path: 'help/contract-statuses', component: HelpContractStatuses },

        //ADMIN
        { path: 'admin/billing', component: AdminBilling },
        { path: 'admin/settings', component: AdminSettings },
        { path: 'admin/settings/do-not-contact-codes', component: AdminDoNotContactCode },
        { path: 'admin/settings/do-not-contact-codes/:id', component: AdminDoNotContactCode, props: true },
        { path: 'admin/settings/marketer-codes', component: AdminMarketerRelationshipCode },
        { path: 'admin/settings/marketer-codes/:id', component: AdminMarketerRelationshipCode, props: true },
        { path: 'admin/settings/contract-statuses', component: AdminContractStatus },
        { path: 'admin/settings/contract-statuses/:id', component: AdminContractStatus, props: true },
        { path: 'admin/settings/product-types', component: AdminProductType },
        { path: 'admin/settings/product-types/:id', component: AdminProductType, props: true },
        { path: 'admin/settings/product-types/:id/delete', component: AdminDeleteProductType, props: true },

        //Agencies
        { path: 'agencies', component: AgencyIndex },
        { path: 'agencies/view/:id', component: AgencyView, props: true },
        { path: 'agencies/create', component: AgencyEdit },
        { path: 'agencies/edit/:id', component: AgencyEdit, props: true },

        //Agents
        { path: 'agents', component: AgentIndex },
        { path: 'agents/create', component: AgentEdit },
        { path: 'agents/edit/:id', component: AgentEdit, props: true },
        { path: 'agents/view/:id', component: AgentView, props: true },
        { path: 'agents/delete/:id', component: AgentDelete, props: true },

        //CARRIERS
        { path: 'carriers', component: CarrierIndex },
        { path: 'carriers/view/:id', component: CarrierView, props: true },
        { path: 'carriers/create', component: CarrierEdit },
        { path: 'carriers/edit/:id', component: CarrierEdit, props: true },
        { path: 'carriers/delete/:id', component: CarrierDelete, props: true },

        //CARRIERS
        { path: 'clients', component: ClientIndex },
        { path: 'clients/view/:id', component: ClientView, props: true },
        { path: 'clients/create', component: ClientEdit, props: true },
        { path: 'clients/edit/:id', component: ClientEdit, props: true },

        //COMMENTS
        { path: 'comments/read', component: CommentsIndex },

        //CONTACTS
        { path: 'contacts/create', component: ContactEdit },
        { path: 'contacts/edit/:id', component: ContactEdit, props: true },
        { path: 'contacts/delete/:id', component: ContactDelete, props: true },

        //CONTRACTS
        { path: 'contracts', component: ContractIndex },
        { path: 'contracts/create', component: ContractEdit },
        { path: 'contracts/edit/:id', component: ContractEdit, props: true },
        { path: 'contracts/view/:id', component: ContractView, props: true },
        { path: 'contracts/delete/:id', component: ContractDelete, props: true },
        { path: 'contracts/deactivate/:id', component: ContractDeactivate, props: true },
        { path: 'contracts/manager-level-change/:id/delete', component: DeleteContractLevelChange, props: true },

        //FILES
        { path: 'files/edit/:id', component: FileEdit, props: true },
        { path: 'files/delete/:id', component: FileDelete, props: true },

        //Policies
        { path: 'policies', component: PolicyIndex },
        { path: 'policies/view/:id', component: PolicyView, props: true },
        { path: 'policies/create', component: PolicyEdit, props: true },
        { path: 'policies/edit/:id', component: PolicyEdit, props: true },

        //Products
        { path: 'products', component: ProductIndex },
        { path: 'products/create', component: ProductEdit, props: true },
        { path: 'products/edit/:id', component: ProductEdit, props: true },
        { path: 'products/view/:id', component: ProductView, props: true },
        { path: 'products/sync-levels/:id', component: ProductSyncLevels, props: true },
        { path: 'products/import', component: ProductImport },
        { path: 'products/import/level-mapping', component: ProductImportLevels },
        { path: 'products/delete/:id', component: ProductDelete, props: true },
        { path: 'products/deactivate/:id', component: ProductDeactivate, props: true },
        { path: 'products/levels/history', component: ProductLevelHistory },

        //REPORTS
        { path: 'reports', component: ReportIndex },
        { path: 'reports/view/:id', component: ReportView, props: true, },
        { path: 'reports/delete/:id', component: ReportDelete, props: true, },
        { path: 'reports/downline', component: ReportDownline },
        { path: 'reports/downline/:id', component: ReportDownline, props: true, },
        { path: 'reports/custom', component: ReportCustom },
        { path: 'reports/custom/:id', component: ReportCustom, props: true },
        { path: 'reports/schedules', component: ScheduleIndex },
        { path: 'reports/schedules/:id', component: ReportEditSchedule, props: true },

        //USERS
        { path: 'users', component: UserIndex },
        { path: 'users/create', component: UserEdit, props: true },
        { path: 'users/edit/:id', component: UserEdit, props: true },
        { path: 'users/view/:id', component: UserView, props: true },
        { path: 'users/reset-password/:id', component: UserResetPassword, props: true },
        { path: 'users/impersonate/:id', component: UserImpersonate, props: true },
      ]
    },
  ]
})

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(() => splashScreen && splashScreen.parentNode.removeChild(splashScreen), 300)
  }

  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading');

  // Store the Route the user came FROM
  localStorage.setItem("AMOS365_Previous_Route", from.path);

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
